import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ss_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ss_token", data.token);
      localStorage.setItem("ss_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("ss_token");
    localStorage.removeItem("ss_user");
    setUser(null);
  };

  const refresh = async () => {
    if (!localStorage.getItem("ss_token")) return null;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("ss_user", JSON.stringify(data));
      return data;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    // refresh user if token exists
    if (localStorage.getItem("ss_token") && !user) {
      api.get("/auth/me").then(({ data }) => {
        setUser(data);
        localStorage.setItem("ss_user", JSON.stringify(data));
      }).catch(() => logout());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
